<template>
  <div>
    <v-card outlined class="px-8 py-4" v-if="showCard">
      <languageSelector
        :addContainer="true"
        :cssProps="'language-selector-in-row max-w-select-lang-login'"
      />

      <br />

      <template v-if="email.length > 0">
        <p v-html="$t('Activate account enter your', { email: email })" />

        <v-form @submit.prevent="activateAccount" ref="form" lazy-validation>
          <v-text-field
            outlined
            dense
            class="mb-4"
            hide-details="auto"
            :label="$t('Password')"
            v-model="pass"
            type="password"
            prepend-inner-icon="mdi-lock"
            required
            validate-on-blur
            :rules="[
              (v) => !!v || $t('Password is required'),
              (v) => (v && v.length > 4) || $t('Password is too short'),
            ]"
          ></v-text-field>

          <v-text-field
            outlined
            dense
            class="mb-4"
            hide-details="auto"
            :label="$t('Repeat password')"
            v-model="repeatPass"
            type="password"
            prepend-inner-icon="mdi-lock"
            required
            validate-on-blur
            :rules="[
              (v) => !!v || $t('Password is required'),
              (v) => (v && v.length > 4) || $t('Password is too short'),
            ]"
          ></v-text-field>

          <div class="text-sm-right">
            <v-btn
              depressed
              class="ml-0 mr-0"
              type="submit"
              :loading="loading"
              color="primary"
              >{{ $t("Activate account") }}</v-btn
            >
          </div>
        </v-form>
      </template>
      <template v-else>
        <preloader></preloader>
      </template>
    </v-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      success: "",
      email: "",
      pass: "",
      repeatPass: "",
      loading: false,
      showCard: true,
    };
  },
  created() {
    this.getActivateAccountEmail();
  },

  methods: {
    setSuccessHandelerReport(event) {
      this.success = event;
    },
    getActivateAccountEmail() {
      this.success = "";
      this.$request.get(
        "/activateaccountemail/" + this.$route.params.hash,
        null,
        (res) => {
          if (res.success) {
            this.email = res.data;
          } else {
            this.showCard = false;
            const toaster = {
              message: res.message,
              timeout: false,
              type: "ERROR",
              toastClassName: ["toaster-color-error", "toaster-layout"],
              bodyClassName: ["toaster-text-layout"],
              icon: "mdi-alert-octagon",
            };
            this.$store.dispatch("setToaster", toaster);
          }
        }
      );
    },
    activateAccount() {
      this.success = "";

      if (this.$refs.form.validate()) {
        this.loading = true;

        this.$request.post(
          "/activateaccount/" + this.$route.params.hash,
          {
            email: this.email,
            password: this.pass,
            passwordrepeat: this.repeatPass,
          },
          (res) => {
            this.loading = false;

            if (res.success) {
              this.success = res.message;
              const toaster = {
                message: res.message,
                timeout: false,
                type: "SUCCESS",
                toastClassName: ["toaster-color-success", "toaster-layout"],
                bodyClassName: ["toaster-text-layout"],
                icon: "mdi-check-circle",
              };
              this.$store.dispatch("setToaster", toaster);
              setTimeout(() => {
                this.$router.replace({ name: "login" });
                this.$router.go(1);
              }, this.$config.hideMessageTimeout);
            } else {
              const toaster = {
                message: res.message,
                timeout: false,
                type: "ERROR",
                toastClassName: ["toaster-color-error", "toaster-layout"],
                bodyClassName: ["toaster-text-layout"],
                icon: "mdi-alert-octagon",
              };
              this.$store.dispatch("setToaster", toaster);
            }
          }
        );
      }
    },
  },
};
</script>

<style>
</style>
